import saymyname from 'assets/projects-images/saymyname.png';
import nexttoaperson from 'assets/projects-images/nexttoaperson.png';
import savethedate from 'assets/projects-images/savethedate.png';
import newsletterfyi from 'assets/projects-images/newsletter-fyi.png';
import halfwaypint from 'assets/projects-images/halfwaypint.png';
import artstories from 'assets/projects-images/artstories.png';
import techtok from 'assets/projects-images/techtok.png';
import zapzipped from 'assets/projects-images/zapzipped.png';
import goagentic from 'assets/projects-images/goagentic.png';

export type Project = {
  name: string;
  link: string;
  label: string;
  image: any;
};

export const projects: Project[] = [
  {
    name: 'Co-founded. Name-pronunciation tool used by millions of students and employees. 3rd place, Product Hunt Golden Kitty 2021.',
    label: 'saymyname.io',
    link: 'https://saymyname.io/cards/joaomartins',
    image: saymyname,
  },
  {
    name: 'AI-powered WhatsApp Wrapped: a bot turns group chat exports into stats and awards without storing data. 100k+ users.',
    label: 'ZapZipped: WhatsApp Wrapped',
    link: 'https://zapzipped.com/?utm_source=portfolio',
    image: zapzipped,
  },
  {
    name: 'A 5-minute daily read on the relentless changes in tech, curated from top news sources into nice-looking stories.',
    label: 'TechTok Daily News & Newsletter',
    link: 'https://techtok.today/?utm_source=portfolio',
    image: techtok,
  },
  {
    name: "Meet your friend halfway in London for a pint. What's the best closest pub in between post codes?",
    link: 'https://halfwaypint.london',
    label: 'halfwaypint.london',
    image: halfwaypint,
  },
  {
    name: 'Measures what AI assistants can answer about a destination, finds the gaps and fixes the supplier data at the source.',
    label: 'GoAgentic: Destination Intelligence',
    link: 'https://goagentic.dev/?utm_source=portfolio',
    image: goagentic,
  },
  {
    name: 'One-stop shop collection of tools for newsletter creators.',
    label: 'Newsletter Hub FYI',
    link: 'https://newsletterhub.fyi',
    image: newsletterfyi,
  },
  {
    name: 'Art Stories. Collecting grandma’s art gallery, enriching painting with AI, displaying gallery in short sentences from life stories.',
    label: 'Art Stories',
    link: 'https://mariamagdalena.art',
    image: artstories,
  },
  {
    name: 'As my wedding guest, you first need to play my game to save the date',
    link: 'https://savethedate.deboraejoao.com',
    label: 'Save the Date!',
    image: savethedate,
  },

  {
    name: "Have you ever bought anything online that wasn't exactly the size you were expecting?",
    link: 'https://nexttoaperson.com',
    label: 'Next to a Person',
    image: nexttoaperson,
  },
  // {
  //   name: 'When moving around London in a group, is it cheaper to get an Uber or the Tube?',
  //   label: 'Tuber',
  //   link: 'https://tuber.london',
  //   image: tuber,
  // },
];
